import { Fragment } from "react";
import Header from "@/components/Header";
import Banner from "@/components/Banner";
import WeDo from "@/components/weDo";
import MissionSection from "@/components/Mission";
import Advantage from "@/components/Advantage";
import Trusted from "@/components/Trusted";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export function OldHome() {
  return (
    <Fragment>
      <Header />
      <Banner />
      <WeDo />
      <MissionSection />
      <Advantage />
      <Trusted />
      <Contact />
      <Footer />
    </Fragment>
  );
}
